import { getCountries } from "libphonenumber-js";
import { Injectable } from '@angular/core';
import { SpinnerService } from './spinner.service';
import { UserManagementService } from '../../admin/services/user-management/user-management.service';
import { BehaviorSubject, Observable } from 'rxjs';
import * as ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';

import {
  CITY_LUNCH_TIME_CONSTANTS,
  CITY_TYPES_CONSTANTS,
  COUNTRY_ISO_CONSTATNS,
  DATE_FORMAT_CONSTATNS,
  MODULE_CONSTANTS,
  OVERRUN_JOB_REASON_CONSTANTS,
  ROLE_CONSTANTS,
  UNBILL_HRS_CODE_CONSTANTS,
  UNBILL_HRS_TYPE_CONSTANTS
} from '../constants/constant';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { cityLunchTime, cityType } from '../../admin/models/city-management/city.model';
import {
  companyInformation,
  countryShortViewModel,
  loggedInUserViewModel,
  roleModuleAccess
} from '../../admin/models/user-management/user_models';
import { TuiCountryIsoCode } from '@taiga-ui/i18n';
import { Router } from '@angular/router';
import moment from 'moment-timezone';
// TODO: (Taiga UI migration) All values inside TuiDateMode are renamed: DMY -> dd/mm/yyyy, MDY -> mm/dd/yyyy, YMD -> yyyy/mm/dd
import { TuiDateMode, TuiDay, TuiDayRange, TuiTime } from '@taiga-ui/cdk';
import { keyValueViewModel } from '../common-model/common.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  //userDetails: any;
  tempUserNameForResetPwd = "";

  public isHideSidebarHeader = new BehaviorSubject<boolean>(true);
  // expose the BehaviorSubject as an Observable
  currentIsHideSidebarValue = this.isHideSidebarHeader.asObservable();

  private _loggedInUserDetails$ = new BehaviorSubject<loggedInUserViewModel>(new loggedInUserViewModel());

  MODE_INST = 'INST';
  MODE_SM = 'SM';
  MODE_DISM = 'DISM';


  get loggedInUserDetails$(): Observable<loggedInUserViewModel> { return this._loggedInUserDetails$.asObservable(); }
  get loggedInUserDetails(): loggedInUserViewModel { return this._loggedInUserDetails$.getValue(); }

  private _moduleDetails$ = new BehaviorSubject<roleModuleAccess[]>([]);
  get moduleDetails$(): Observable<roleModuleAccess[]> { return this._moduleDetails$.asObservable(); }
  get moduleDetails(): roleModuleAccess[] { return this._moduleDetails$.getValue(); }

  userDetails!: loggedInUserViewModel;

  constructor(private spinerService: SpinnerService, private userService: UserManagementService, private router: Router) {
  }
  updateIsHideHeaderSidebar(value: boolean) {
    this.isHideSidebarHeader.next(value);
  }
  GetLoggedInUserDetails() {
    this.userService.GetLoggedInUserDetails().subscribe({
      next: (res: loggedInUserViewModel) => {
        if (res != null && res != undefined) {
          this.setLoggedUserDetails(res);
        }
      },
      error: (error) => {
        this.spinerService.hide();
      }
    });
  }
  convertUTCTimeToTimezone(dateTime: string) {
    const tz = localStorage.getItem('tz') || "";
    // if (this.isNotNULLEmptyUndefind(tz)) {
    //   return moment(dateTime).tz(tz).format().toString()
    // } else {
    //   return dateTime;
    // }
    if (this.isNotNULLEmptyUndefind(tz)) {
      return this.convertUTCToTimezoneWithIana(dateTime, tz);
    } else {
      return dateTime;
    }
  }
  getDialCode(dialCode: string) {
    if (dialCode === "+1_") {
      return "+1";
    }
    if (!this.isNotNULLEmptyUndefind(dialCode)) {
      return "+1";
    }
    return dialCode;
  }

  setLoggedUserDetails(res: loggedInUserViewModel) {
    this.userDetails = res;
    this.setLoggedInUser(res);

    // Set local storage
    localStorage.setItem('tz', res.timezoneName);
    localStorage.setItem('todaysDate', res.todaysDate);
    localStorage.setItem('modules', JSON.stringify(res.moduleAccess));
    localStorage.setItem('companyInfo', JSON.stringify(res.companyInfo));
    localStorage.setItem('defaultProfileCityId', res.cityId);
    localStorage.setItem('defaultProfileBaseCityId', res.baseCityId);

    // Emit new values via BehaviorSubjects
    this._loggedInUserDetails$.next(res);
    this._moduleDetails$.next(res.moduleAccess || []);

    if (!this.isNotNULLEmptyUndefindArray(res.moduleAccess)) {
      this.router.navigate(['user-profile']);
    }

    this.parseModuleAccess();
  }


  getModuleAccess(): roleModuleAccess[] {
    const stored = localStorage.getItem('modules');
    if (this.isNotNULLEmptyUndefind(stored)) {
      const jsonObj = JSON.parse(stored || '');
      if (this.isNotNULLEmptyUndefindArray(jsonObj)) {
        return jsonObj as roleModuleAccess[];
      }
    }
    return [];
  }

  getCompanyInfo(): companyInformation {
    if (this.isNotNULLEmptyUndefind(localStorage.getItem('companyInfo'))) {
      let jsonObj = JSON.parse(localStorage.getItem('companyInfo') || '');
      if (this.isNotNULLEmptyUndefind(jsonObj)) {
        return jsonObj as companyInformation;
      }
    }
    return { companyName: "Company", appVersion: "1", addressLine1: "", addressLine2: "", addressLine3: "", phoneNumber: "", url: "", email: "" } as companyInformation;
  }
  parseModuleAccess() {
    this.setModuleAccessInUser(this.getModuleAccess());
  }
  setLoggedInUser(data: loggedInUserViewModel) {
    this._loggedInUserDetails$.next(data);
  }
  setModuleAccessInUser(data: roleModuleAccess[]) {
    this._moduleDetails$.next(data);
  }
  isNotNULLEmptyUndefind(data: any) {
    if (data !== undefined && data !== null && data !== "" && data !== "null") {
      return true;
    }
    return false;
  }
  isNotNULLEmptyUndefindArray(data: any) {
    if (data !== undefined && data !== null && data.length > 0) {
      return true;
    }
    return false;
  }
  passwordMatch: ValidatorFn = (
    control: AbstractControl,
  ): ValidationErrors | null => {
    const name = control.get('password');
    const alterEgo = control.get('confirmPassword');
    return name && alterEgo && name.value !== alterEgo.value
      ? { mismatch: true }
      : null;
  };

  getCityTypes() {
    let cityTypes: Array<cityType> = [];

    let cityTypeBase = new cityType();
    cityTypeBase.cityTypeKey = CITY_TYPES_CONSTANTS.BASE_CITY_KEY;
    cityTypeBase.cityTypeDisplayName = CITY_TYPES_CONSTANTS.BASE_CITY_DISPLAY_NAME;
    cityTypeBase.isSubContractorCity = false;
    cityTypes.push(cityTypeBase)

    let cityTypeTier = new cityType();
    cityTypeTier.cityTypeKey = CITY_TYPES_CONSTANTS.TIER_2_CITY;
    cityTypeTier.cityTypeDisplayName = CITY_TYPES_CONSTANTS.TIER_2_CITY_DISPLAY_NAME;
    cityTypeTier.isSubContractorCity = false;
    cityTypes.push(cityTypeTier)

    let cityTypeSubContractor = new cityType();
    cityTypeSubContractor.cityTypeKey = CITY_TYPES_CONSTANTS.BASE_CITY_KEY;
    cityTypeSubContractor.cityTypeDisplayName = CITY_TYPES_CONSTANTS.BASE_CITY_SUBCONTRACTOR_DISPLAY_NAME;
    cityTypeSubContractor.isSubContractorCity = true;

    cityTypes.push(cityTypeSubContractor)

    return cityTypes;
  }
  getBaseAndTierCityTypes() {
    let cityTypes: Array<cityType> = [];

    let cityTypeBase = new cityType();
    cityTypeBase.cityTypeKey = CITY_TYPES_CONSTANTS.BASE_CITY_KEY;
    cityTypeBase.cityTypeDisplayName = CITY_TYPES_CONSTANTS.BASE_CITY_DISPLAY_NAME;
    cityTypes.push(cityTypeBase)

    let cityTypeTier = new cityType();
    cityTypeTier.cityTypeKey = CITY_TYPES_CONSTANTS.TIER_2_CITY;
    cityTypeTier.cityTypeDisplayName = CITY_TYPES_CONSTANTS.TIER_2_CITY_DISPLAY_NAME;
    cityTypes.push(cityTypeTier)

    return cityTypes;
  }
  getCityLunchTime() {
    let cityLunchTimes: Array<cityLunchTime> = [];

    let noLunch = new cityLunchTime();
    noLunch.cityLunchTimeKey = CITY_LUNCH_TIME_CONSTANTS.NO_LUNCH_TIME_KEY;
    noLunch.cityLunchTimeDisplayName = CITY_LUNCH_TIME_CONSTANTS.NO_LUNCH_TIME_DISPLAY_NAME;
    cityLunchTimes.push(noLunch)

    let halfHourTime = new cityLunchTime();
    halfHourTime.cityLunchTimeKey = CITY_LUNCH_TIME_CONSTANTS.HALF_HOUR_LUNCH_TIME_KEY;
    halfHourTime.cityLunchTimeDisplayName = CITY_LUNCH_TIME_CONSTANTS.HALF_HOUR_LUNCH_TIME_DISPLAY_NAME;
    cityLunchTimes.push(halfHourTime)

    let oneHourTime = new cityLunchTime();
    oneHourTime.cityLunchTimeKey = CITY_LUNCH_TIME_CONSTANTS.ONE_HOUR_LUNCH_TIME_KEY;
    oneHourTime.cityLunchTimeDisplayName = CITY_LUNCH_TIME_CONSTANTS.ONE_HOUR_LUNCH_TIME_DISPLAY_NAME;
    cityLunchTimes.push(oneHourTime)

    return cityLunchTimes;
  }

  mapCountriesISOCodeForPhone(allCountryList: countryShortViewModel[]): TuiCountryIsoCode[] {
    let countries: TuiCountryIsoCode[] = [];
    if (this.isNotNULLEmptyUndefindArray(allCountryList)) {
      allCountryList.forEach(element => {
        if (getCountries().includes(<TuiCountryIsoCode>element.countryISOCode)) {
          countries.push(<TuiCountryIsoCode>element.countryISOCode);
        }
      });
    }
    return countries;
  }
  
   mapCountriesISOCodeForPhoneNew(allCountryList: countryShortViewModel[], metaCountries: TuiCountryIsoCode[]): TuiCountryIsoCode[] {
    let countries: TuiCountryIsoCode[] = [];
    if (this.isNotNULLEmptyUndefindArray(allCountryList)) {
      allCountryList.forEach(element => {
        if (metaCountries.includes(<TuiCountryIsoCode>element.countryISOCode)) {
          countries.push(<TuiCountryIsoCode>element.countryISOCode);
        }
      });
    }
    return countries;
  }

  getPhoneISOCodeByDialCode(dialCode: string, allCountryList: countryShortViewModel[]): TuiCountryIsoCode[] {
    let countries: TuiCountryIsoCode[] = [];
    if (this.isNotNULLEmptyUndefindArray(allCountryList) && this.isNotNULLEmptyUndefind(dialCode)) {
      if (dialCode === "+1_") {
        let findCountry = allCountryList.filter(r => r.countryISOCode === COUNTRY_ISO_CONSTATNS.CANADA);
        if (this.isNotNULLEmptyUndefindArray(findCountry)) {
          if (getCountries().includes(<TuiCountryIsoCode>findCountry[0].countryISOCode)) {
            countries.push(<TuiCountryIsoCode>findCountry[0].countryISOCode);
          }
        }
      } else if (dialCode === "+1") {
        let findCountry = allCountryList.filter(r => r.countryISOCode === COUNTRY_ISO_CONSTATNS.US);
        if (this.isNotNULLEmptyUndefindArray(findCountry)) {
          if (getCountries().includes(<TuiCountryIsoCode>findCountry[0].countryISOCode)) {
            countries.push(<TuiCountryIsoCode>findCountry[0].countryISOCode);
          }
        }
      } else {
        let findCountry = allCountryList.filter(r => r.dialCode === dialCode);
        if (this.isNotNULLEmptyUndefindArray(findCountry)) {
          if (getCountries().includes(<TuiCountryIsoCode>findCountry[0].countryISOCode)) {
            countries.push(<TuiCountryIsoCode>findCountry[0].countryISOCode);
          }
        }
      }
    }
    return countries;
  }

  getTUIDayFormat(dateTime: any): TuiDay {
    const checkEndDate = moment(dateTime, DATE_FORMAT_CONSTATNS.YYYY_MM_DD_MOMENT);
    const month = checkEndDate.format('M');
    const day = checkEndDate.format('D');
    const year = checkEndDate.format('YYYY');
    return new TuiDay(parseInt(year), parseInt(month) - 1, parseInt(day));
  }
  getTUITimeFormat(timeSpan: any) {
    if (timeSpan.hours.toString().length === 1) {
      timeSpan.hours = "0" + timeSpan.hours;
    }
    if (timeSpan.minutes.toString().length === 1) {
      timeSpan.minutes = "0" + timeSpan.minutes;
    }
    if (timeSpan.seconds.toString().length === 1) {
      timeSpan.seconds = "0" + timeSpan.seconds;
    }
    let tm = timeSpan.hours + ":" + timeSpan.minutes + ":" + timeSpan.seconds;
    return tm;
  }
  getDateStringYYYYMMDD = (dateTime: string): string => {
    const dtFormatYYYYMMDD = "YYYY-MM-DD";
    return moment(new Date(dateTime)).format(dtFormatYYYYMMDD);
  };

  getDateStringYYYYMMDDddd = (dateTime: string): string => {
    // const [datePart] = dateTime.split('T');
    // const [year, month, day] = datePart.split('-');
    // const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    // const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    // const dayOfWeek = days[date.getUTCDay()];
    // const returnValue = `${year}-${month}-${day} ${dayOfWeek}`;
    return moment(dateTime).format('YYYY-MM-DD ddd');
  };

  getAllDaysBetweenDates = (startDate: string, endDate: string): Date[] => {
    const datesList: Date[] = [], currentDate = new Date(startDate), endDt = new Date(endDate);
    while (currentDate <= endDt) {
      datesList.push(new Date(currentDate));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return datesList;
  };

  getNumberRoundedToNearestHalf = (inputNum: any): number => {
    //return Math.round(+inputNum * 2) / 2;
    const integerPart = Math.floor(inputNum);
    const decimalPart = inputNum - integerPart;

    if (decimalPart < 0.5) {
      return integerPart;
    } else if (decimalPart === 0.5) {
      return integerPart + 0.5;
    } else {
      return integerPart + 1;
    }
  };

  getAmPmTimeFrom24Time(time24h: string): string {
    if (time24h) {
      if (time24h === '') {
        return '';
      }
    }
    else { return ''; }
    const regExAmPm = /^([0]?[1-9]|1[0-2]):([0-5]\d)\s?(AM|PM)$/i;
    if (regExAmPm.test(time24h)) {
      return time24h;
    }
    if (time24h === '00:00:00') {
      return '12:00 AM';
    }
    const [hours, minutes] = time24h.split(':');
    let hour = parseInt(hours, 10);
    const modifier = hour >= 12 ? 'PM' : 'AM';

    if (hour > 12) {
      hour -= 12;
    } else if (hour === 0) {
      hour = 12;
    }
    let mins = '00';
    if (minutes.length > 2) {
      const [newMin, newAppend] = minutes.split(' ');
      mins = newMin;
    } else {
      mins = minutes;
    }

    return `${hour.toString().padStart(2, '0')}:${mins.toString().padEnd(2, '0')} ${modifier}`;
  }

  getNumberTimeFromTimeAmPmString = (clockTime: string): number => {
    let eTime = 0;
    if (this.isNotNULLEmptyUndefind(clockTime)) {
      const subStrTime = clockTime.substring(0, 5);
      const amPm = clockTime.substring(6, 8);
      const arrSTime = subStrTime.split(':');
      let eTimeS = +arrSTime[0];
      let eTimeE = +arrSTime[1];
      if ('AM' === amPm) {
        //12:00 AM -> 0:00
        if (eTimeS === 12 && eTimeE < 30) {
          eTimeS = 0;
        }
        if (eTimeS === 12 && eTimeE === 30) {
          eTimeS = 0;
        }
      } else if (amPm === 'PM') {
        if (eTimeS !== 12) {
          eTimeS = eTimeS + 12;
        }
      }
      eTimeE = (eTimeE / 60);
      eTime = eTimeS + eTimeE;
    }
    return eTime;
  };

  getTimeStringAmPmTimeFromDecimal(decimalTime: number): string {
    if (decimalTime < 0 || decimalTime >= 24) {
      return "Invalid input. Decimal time must be between 0 and 24.";
    }

    const hours = Math.floor(decimalTime);
    const minutes = Math.round((decimalTime - hours) * 60);

    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert 0 to 12 for AM/PM

    return `${formattedHours.toString().padStart(2, "0")}:${minutes.toString().padEnd(2, "0")} ${ampm}`;
  }

  getTimeStringFromDecimal(decimalTime: number): string {
    const hours = Math.floor(decimalTime);
    const minutes = Math.round((decimalTime - hours) * 100);
    const formattedMinutes = minutes.toString().padEnd(2, '0');
    const resultString = `${hours.toString().padStart(2, '0').padEnd(2, '0')}.${formattedMinutes} Hrs`;
    return resultString;
  }

  addDecimalTimeToClockTime(clockTime: string, decimalTime: number): string {
    // Parse the clock time (e.g., "1:30 AM")
    const [hoursStrClockTime, minutesStrClockTime, period] = clockTime.split(/[:\s]/);
    // const hoursIntClockTime = parseInt(hoursStrClockTime);
    // const minutesIntClockTime = parseInt(minutesStrClockTime);

    const numberTimeFromClockTime = this.getNumberTimeFromTimeAmPmString(clockTime);

    const newTime = numberTimeFromClockTime + decimalTime;
    // const newTotalHours = Math.floor(newTime);
    // const newTotalMinutes = newTime % 60;
    const newPeriod = newTime >= 12 ? "PM" : "AM";

    const formattedHours = newTime >= 24 ? 11 : ((newTime === 0 || ((newTime >= 12) && (newTime < 13))) ? 12 : (Math.floor(newTime) % 12).toString().padStart(2, '0'));
    const formattedMinutes = newTime >= 24 ? 59 : (((newTime - Math.floor(newTime)) * 60).toString().padStart(2, '0'));
    const result = `${formattedHours}:${formattedMinutes} ${newPeriod}`;
    return result;
  }

  getLastWeekDates(): { startOfLastWeek: Date, endOfLastWeek: Date } {
    const now = new Date();
    const dayOfWeek = now.getDay(); // 0 (Sunday) to 6 (Saturday)
    const diffToLastMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1;
    const diffToLastSunday = dayOfWeek === 0 ? 7 : dayOfWeek;

    const startOfLastWeek = new Date(now);
    startOfLastWeek.setDate(now.getDate() - diffToLastMonday - 7);
    startOfLastWeek.setHours(0, 0, 0, 0);

    const endOfLastWeek = new Date(now);
    endOfLastWeek.setDate(now.getDate() - diffToLastSunday);
    endOfLastWeek.setHours(23, 59, 59, 999);

    return { startOfLastWeek, endOfLastWeek };
  }

  calculateTimePercentage(start: string, end: string): number {
    const amOrPmRegex = /am|pm/i;
    let arrStartTime: string[] = [];
    let arrEndTime: string[] = [];

    if (amOrPmRegex.test(start)) {
      const [timeS, ampmS] = start.split(/\s+/);
      arrStartTime = timeS.split(':');
      let timeHS = +arrStartTime[0];
      const timeMS = +arrStartTime[1];
      if (ampmS === 'PM' && timeHS < 12 && timeMS != 59) {
        timeHS += 12;
        arrStartTime[0] = timeHS.toString();
      }
    } else {
      arrStartTime = start.split(':');
    }

    if (amOrPmRegex.test(end)) {
      const [timeE, ampmE] = end.split(/\s+/);
      arrEndTime = timeE.split(':');
      let timeHE = +arrEndTime[0];
      const timeME = +arrEndTime[1];
      if (ampmE === 'PM' && timeHE < 12 && timeME != 59) {
        timeHE += 12;
        arrEndTime[0] = timeHE.toString();
      }
    } else {
      arrEndTime = end.split(':');
    }

    const totalMinutesInADay = 24 * 60;

    // Convert start and end times to minutes since midnight
    const [startHours, startMinutes] = arrStartTime.map(Number);
    const [endHours, endMinutes] = arrEndTime.map(Number);
    const totalMinutesStart = (startHours * 60) + startMinutes;
    const totalMinutesEnd = ((endHours > 23 ? endHours - 24 : endHours) * 60) + endMinutes;

    // Calculate the total time span in minutes
    const totalTimeSpan = (totalMinutesEnd - totalMinutesStart + totalMinutesInADay) % totalMinutesInADay;

    // Calculate the percentage
    let percentage = 100;
    if (totalMinutesEnd < 1440 || totalMinutesStart < 1440) {
      percentage = (totalTimeSpan / totalMinutesInADay) * 100;
    }
    return percentage;
  }
  //======================
  calculateTimePercentageAll(start: string, end: string): {
    dayEndTimePerc: number;
    jobStartTimePerc: number;
    dayStartTimePerc: number
  } {
    const dayStartTimePerc = this.calculateTimePercentage('00:00', start);
    const jobStartTimePerc = this.calculateTimePercentage(start, end);
    const dayEndTimePerc = this.calculateTimePercentage(end, '23:59');
    const result = { 'dayStartTimePerc': dayStartTimePerc, 'jobStartTimePerc': jobStartTimePerc, 'dayEndTimePerc': dayEndTimePerc };
    return result;
  }

  getPercentageDayStart(jobDateItem: AbstractControl | null | undefined, stKey: string): number {
    let dayStartTimePerc = 0;
    if (jobDateItem) {
      const sTime = jobDateItem?.get(stKey)?.value;
      if (sTime) {
        console.log('sTime = ' + sTime);
        dayStartTimePerc = this.calculateTimePercentage('00:00', sTime);
      }
    }
    return dayStartTimePerc;
  }
  getPercentageJob(jobDateItem: AbstractControl, stKey: string, etKey: string): number {

    const sTime = jobDateItem.get(stKey)?.value;
    const eTime = jobDateItem.get(etKey)?.value;
    const jobTimePerc = this.calculateTimePercentage(sTime, eTime);
    return jobTimePerc;
  }
  getPercentageDayEnd(jobDateItem: AbstractControl, etKey: string): number {
    const eTime = jobDateItem.get(etKey)?.value;
    const dayEndTimePerc = this.calculateTimePercentage(eTime, '23:59');
    return dayEndTimePerc;
  }

  // checkSOAddUpdatePermission(soDetails:soViewModelForDetails) {
  //   if(this.isNotNULLEmptyUndefind(soDetails)) {
  //     if(soDetails.requestStatusKey === SO_STATUS_CONSTANTS.STATUS_CANCELED_KEY ||
  //       soDetails.requestStatusKey === SO_STATUS_CONSTANTS.STATUS_WON_KEY
  //     ) {
  //       return false;
  //     }
  //     if(soDetails.soClientApprovedStatusKey === SO_STATUS_CONSTANTS.SENT_FOR_APPROVAL_KEY ||
  //       soDetails.soClientApprovedStatusKey === SO_STATUS_CONSTANTS.APPROVED_KEY||
  //       soDetails.soClientApprovedStatusKey === SO_STATUS_CONSTANTS.NOT_APPROVED_KEY
  //     ) {
  //       return false;
  //     }
  //   }
  //   let isAllowd = false;
  //   if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.CITY_MANAGER ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ASSISTANT_CITY_MANAGER ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_SUERVISOR ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ESTIMATOR ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNTING ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_EXECUTIVE ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.LEAD_MAN) {
  //     isAllowd =  false;
  //   }
  //   else if(localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_COORDINATOR ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_MANAGER ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ADMIN) {
  //     isAllowd =  true;
  //   }
  //   return isAllowd;
  // }
  // checkSOAddUpdatePermissionOnly() {
  //   let isAllowd = false;
  //   if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.CITY_MANAGER ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ASSISTANT_CITY_MANAGER ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_SUERVISOR ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ESTIMATOR ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNTING ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_EXECUTIVE ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.LEAD_MAN) {
  //     isAllowd =  false;
  //   }
  //   else if(localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_COORDINATOR ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_MANAGER ||
  //   localStorage.getItem('roleKey') === ROLE_CONSTANTS.ADMIN) {
  //     isAllowd =  true;
  //   }
  //   return isAllowd;
  // }

  navigateToDashboardByRoleKey() {
    if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.CITY_MANAGER ||
      localStorage.getItem('roleKey') === ROLE_CONSTANTS.ASSISTANT_CITY_MANAGER ||
      localStorage.getItem('roleKey') === ROLE_CONSTANTS.REGIONAL_CITY_MANAGER) {
      this.router.navigate(['/dashboard-cm']);
    } else if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNTING) {
      this.router.navigate(['/dashboard-accounting']);
    } else if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.ESTIMATOR) {
      this.router.navigate(['/so/list']);
    }
    else if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_COORDINATOR) {
      this.router.navigate(['/dashboard-account-coordinator']);
    }
    else if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_MANAGER) {
      this.router.navigate(['/calendar-view-as-am']);
    }
    else if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_SUPERVISOR) {
      this.router.navigate(['/calendar-view-as-am']);
    }
    else if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.ACCOUNT_EXECUTIVE) {
      this.router.navigate(['/account-executive/dashboard']);
    }
    else if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.LEADERSHIP_SALES) {
      this.router.navigate(['/leadership-sales/dashboard']);
    }
    else if (localStorage.getItem('roleKey') === ROLE_CONSTANTS.LEADERSHIP_OPERATIONS) {
      this.router.navigate(['/leadership-operations/dashboard']);
    }
    else {
      this.router.navigate(['/dashboard']);
    }
  }

  /**
   * Check if two dates are in the same year and month.
   * @param inputDateStr - First date in YYYY-MM-DD format.
   * @param compareDateStr - Second date in YYYY-MM-DD format.
   * @returns true if both dates are in the same year and month, otherwise false.
   */
  areDatesInSameYearAndMonth(inputDateStr: string, compareDateStr: string): boolean {
    if (inputDateStr && compareDateStr) {
      // Parse the date strings into Date objects
      const inputDate = new Date(inputDateStr);
      const compareDate = new Date(compareDateStr);

      // Check for invalid dates
      if (isNaN(inputDate.getTime()) || isNaN(compareDate.getTime())) {
        throw new Error('Invalid date format');
      }

      // Convert dates to ISO strings to ensure they are in UTC
      const inputDateUTC = new Date(inputDate.toISOString());
      const compareDateUTC = new Date(compareDate.toISOString());

      // Extract year and month
      const year1 = inputDateUTC.getUTCFullYear();
      const month1 = inputDateUTC.getUTCMonth();
      const year2 = compareDateUTC.getUTCFullYear();
      const month2 = compareDateUTC.getUTCMonth();

      // Compare year and month
      return year1 === year2 && month1 === month2;
    }
    return false;
  }

  getUnbillHrsType() {
    let keyValueList: Array<keyValueViewModel> = [];

    let item1: keyValueViewModel = {
      key: UNBILL_HRS_TYPE_CONSTANTS.TRAVEL_TIME_KEY,
      value: UNBILL_HRS_TYPE_CONSTANTS.TRAVEL_TIME_DISPLAY,
    };
    keyValueList.push(item1)

    let item2: keyValueViewModel = {
      key: UNBILL_HRS_TYPE_CONSTANTS.EQUIPMENT_TIME_KEY,
      value: UNBILL_HRS_TYPE_CONSTANTS.EQUIPMENT_TIME_DISPLAY,
    };
    keyValueList.push(item2)

    let item3: keyValueViewModel = {
      key: UNBILL_HRS_TYPE_CONSTANTS.SHOW_TIME_KEY,
      value: UNBILL_HRS_TYPE_CONSTANTS.SHOW_TIME_DISPLAY,
    };
    keyValueList.push(item3)

    let item4: keyValueViewModel = {
      key: UNBILL_HRS_TYPE_CONSTANTS.LABOR_ERROR_KEY,
      value: UNBILL_HRS_TYPE_CONSTANTS.LABOR_ERROR_DISPLAY,
    };
    keyValueList.push(item4);

    keyValueList.sort((n1, n2) => {
      if (n1.value > n2.value) {
        return 1;
      }
      if (n1.value < n2.value) {
        return -1;
      }
      return 0;
    });
    return keyValueList;
  }

  getUnbillHrsCode() {
    let keyValueList: Array<keyValueViewModel> = [];

    let item1: keyValueViewModel = {
      key: UNBILL_HRS_CODE_CONSTANTS.NON_DEDUCTIBLE_TIME_KEY,
      value: UNBILL_HRS_CODE_CONSTANTS.NON_DEDUCTIBLE_TIME_DISPLAY,
    };
    keyValueList.push(item1);

    let item2: keyValueViewModel = {
      key: UNBILL_HRS_CODE_CONSTANTS.DEDUCTIBLE_TIME_KEY,
      value: UNBILL_HRS_CODE_CONSTANTS.DEDUCTIBLE_TIME_DISPLAY,
    };
    keyValueList.push(item2);

    keyValueList.sort((n1, n2) => {
      if (n1.value > n2.value) {
        return 1;
      }
      if (n1.value < n2.value) {
        return -1;
      }
      return 0;
    });

    return keyValueList;
  }

  getJobOverRunReasons() {
    let keyValueList: Array<keyValueViewModel> = [];

    let item1: keyValueViewModel = {
      key: OVERRUN_JOB_REASON_CONSTANTS.CUSTOMER_REQUIREMENT_ACCOMMODATED_KEY,
      value: OVERRUN_JOB_REASON_CONSTANTS.CUSTOMER_REQUIREMENT_ACCOMMODATED_DISPLAY,
    };
    keyValueList.push(item1);

    let item2: keyValueViewModel = {
      key: OVERRUN_JOB_REASON_CONSTANTS.FREIGHT_ISSUES_KEY,
      value: OVERRUN_JOB_REASON_CONSTANTS.FREIGHT_ISSUES_DISPLAY,
    };
    keyValueList.push(item2);

    let item3: keyValueViewModel = {
      key: OVERRUN_JOB_REASON_CONSTANTS.ELECTRIC_ISSUES_KEY,
      value: OVERRUN_JOB_REASON_CONSTANTS.ELECTRIC_ISSUES_DISPLAY,
    };
    keyValueList.push(item3);

    let item4: keyValueViewModel = {
      key: OVERRUN_JOB_REASON_CONSTANTS.HANGING_SIGN_ISSUE_KEY,
      value: OVERRUN_JOB_REASON_CONSTANTS.HANGING_SIGN_ISSUE_DISPLAY,
    };
    keyValueList.push(item4);

    let item5: keyValueViewModel = {
      key: OVERRUN_JOB_REASON_CONSTANTS.ESTIMATE_ISSUE_KEY,
      value: OVERRUN_JOB_REASON_CONSTANTS.ESTIMATE_ISSUE_DISPLAY,
    };
    keyValueList.push(item5);

    let item6: keyValueViewModel = {
      key: OVERRUN_JOB_REASON_CONSTANTS.POOR_LABOR_KEY,
      value: OVERRUN_JOB_REASON_CONSTANTS.POOR_LABOR_DISPLAY,
    };
    keyValueList.push(item6);

    return keyValueList;
  }
  getWeekFromDate(date: any): string {
    // // Ensure the date is a Date object
    // const inputDate = new Date(date);

    // // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    // const dayOfWeek = inputDate.getDay();

    // // Calculate the difference to the previous Monday
    // const diffToMonday = (dayOfWeek + 6) % 7;

    // // Calculate the Monday and Sunday of the week
    // const monday = new Date(inputDate);
    // monday.setDate(inputDate.getDate() - diffToMonday);

    // const sunday = new Date(monday);
    // sunday.setDate(monday.getDate() + 6);

    // // Format the dates to yyyy-MM-dd
    // const formatDate = (date: Date): string => {
    //   const yyyy = date.getFullYear();
    //   const mm = String(date.getMonth() + 1).padStart(2, '0');
    //   const dd = String(date.getDate()).padStart(2, '0');
    //   return `${yyyy}-${mm}-${dd}`;
    // };

    // return `${formatDate(monday)} - ${formatDate(sunday)}`;

    // let currentDate = moment(date);
    // var monday = currentDate.clone().weekday(1);
    // var friday = currentDate.clone().weekday(7);
    // let dt = monday.format("YYYY-MM-DD") +" - "+ friday.format("YYYY-MM-DD")
    // return dt;
    return this.geWeekStartByDate(date) + " - " + this.geWeekEndByDate(date);
  }

  getWeekFromDateString(dateString: string): string {
    // Parse the input date string
    const [year, month, day] = dateString.split('-').map(Number);
    const inputDate = new Date(year, month - 1, day);

    // Get the day of the week (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
    const dayOfWeek = inputDate.getDay();

    // Calculate the difference to the previous Monday
    const diffToMonday = (dayOfWeek + 6) % 7;

    // Calculate the Monday and Sunday of the week
    const monday = new Date(inputDate);
    monday.setDate(inputDate.getDate() - diffToMonday);

    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);

    // Format the dates to yyyy-MM-dd
    const formatDate = (date: Date): string => {
      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const dd = String(date.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    };

    return `${formatDate(monday)} - ${formatDate(sunday)}`;
  }

  convertUTCToTimezoneWithIana(utcDateTime: string, ianaTimeZone: string): string {
    try {
      // // Create a Date object from the UTC DateTime string
      // const date = new Date(utcDateTime);

      // // Convert the date to the specified timezone
      // const convertedDate = new Date(date.toLocaleString('en-US', { timeZone: ianaTimeZone }));

      // return convertedDate.toString();
      var dtstring = moment.utc(utcDateTime, "").tz(ianaTimeZone).format("YYYY-MM-DD HH:mm:ss");
      return dtstring;
    } catch (error) {
      console.error("Error converting date:", error);
      return utcDateTime;
    }
  }

  getTUIDayLastWeekStart() {
    let dateFrom = this.getLastWeekDates();
    return this.getTUIDayFormat(moment(dateFrom.startOfLastWeek).format('YYYY-MM-DD'));
  }
  getTUIDayLastWeekEnd() {
    let dateFrom = this.getLastWeekDates();
    return this.getTUIDayFormat(moment(dateFrom.startOfLastWeek).endOf('week').format('YYYY-MM-DD'));
  }
  getTUIDayLastMonthStart() {
    let dateFrom = moment(localStorage.getItem("todayDate")).subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
    return this.getTUIDayFormat(dateFrom);
  }
  getTUIDayLastMonthEnd() {
    let dateFrom = moment(localStorage.getItem("todayDate")).subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
    return this.getTUIDayFormat(dateFrom);
  }
  getTUIDay90DaysFromCurrent() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(90, 'days').format("YYYY-MM-DD")));
  }
  getTUIDay60DaysFromCurrent() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(60, 'days').format("YYYY-MM-DD")));
  }
  getTUIDay30DaysFromCurrent() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(30, 'days').format("YYYY-MM-DD")));
  }
  getTUIDay90DaysAgo() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(-90, 'days').format("YYYY-MM-DD")));
  }
  getTUIDay60DaysAgo() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(-60, 'days').format("YYYY-MM-DD")));
  }
  getTUIDay30DaysAgo() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(-30, 'days').format("YYYY-MM-DD")));
  }
  getTUIDayToday() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).format("YYYY-MM-DD")));
  }
  getTUIDayFuture25YearFromToday() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(25, 'year').format("YYYY-MM-DD")));
  }
  getTUIDayYesterday() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(-1, 'day').format("YYYY-MM-DD")));
  }
  getTUIDayIfCurrentWeekStartDateIsTodaysDate() {
    if (moment(localStorage.getItem("todaysDate")).startOf("week").add(1, 'day').format("YYYY-MM-DD") === (moment(localStorage.getItem("todaysDate")).format("YYYY-MM-DD"))) {
      return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).startOf("week").add(1, 'day').format("YYYY-MM-DD")));
    }
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(-1, 'day').format("YYYY-MM-DD")));
  }
  getCurrentWeekStart() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).startOf("week").add(1, 'day').format("YYYY-MM-DD")));
  }
  getCurrentWeekEnd() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).endOf("week").add(1, 'day').format("YYYY-MM-DD")));
  }

  getLastWeekStart() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).startOf("week").add(-6, 'day').format("YYYY-MM-DD")));
  }
  getLastWeekEnd() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).startOf("week").format("YYYY-MM-DD")));
  }

  getNextWeekStart() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).endOf("week").add(2, 'day').format("YYYY-MM-DD")));
  }
  getNextWeekEnd() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).endOf("week").add(8, 'day').format("YYYY-MM-DD")));
  }
  getLastMonthStart() {
    return this.getTUIDayFormat((moment(moment(localStorage.getItem("todaysDate")).startOf("month").add(-1, 'day').format("YYYY-MM-DD")).startOf("month").format("YYYY-MM-DD")));
  }
  getLastMonthEnd() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).startOf("month").add(-1, 'day').format("YYYY-MM-DD")));
  }
  getThisMonthStart() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).startOf("month").format("YYYY-MM-DD")));
  }
  getThisMonthEndTillYesterdaysDate() {
    if (moment(localStorage.getItem("todaysDate")).startOf("month").format("YYYY-MM-DD") === (moment(localStorage.getItem("todaysDate")).format("YYYY-MM-DD"))) {
      return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).startOf("month").format("YYYY-MM-DD")));
    }
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(-1, 'day').format("YYYY-MM-DD")));
  }
  getThisMonthEnd() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).endOf("month").format("YYYY-MM-DD")));
  }
  getNextMonthStart() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).endOf("month").add(1, 'day').format("YYYY-MM-DD")));
  }
  getNextMonthEnd() {
    return this.getTUIDayFormat((moment(moment(localStorage.getItem("todaysDate")).endOf("month").add(1, 'day').format("YYYY-MM-DD")).endOf("month").format("YYYY-MM-DD")));
  }
  getLastWeekStartDate() {
    return (moment(localStorage.getItem("todaysDate")).startOf("week").add(-6, 'day').format("YYYY-MM-DD"));
  }
  geWeekStartByDate(date: string) {
    if (moment(date).day() === 0) { //Sunday
      return (moment(date).add(-6, 'day').format("YYYY-MM-DD"));
    }
    return (moment(date).startOf("week").add(1, 'day').format("YYYY-MM-DD"));
  }
  geWeekEndByDate(date: string) {
    return (moment(this.geWeekStartByDate(date)).add(6, 'day').format("YYYY-MM-DD"));
  }
  
  getLastWeekFromToday() {
    return this.getTUIDayFormat(moment(localStorage.getItem("todaysDate")).add(-6, 'day').format("YYYY-MM-DD"));
  }
  getLastMonthFromToday() {
    return this.getTUIDayFormat(moment(localStorage.getItem("todaysDate")).add(-1, 'month').format("YYYY-MM-DD"));
  }
  getLastQuarterFromToday() {
    return this.getTUIDayFormat(moment(localStorage.getItem("todaysDate")).add(-3, 'month').format("YYYY-MM-DD"));
  }
  getLastYearFromToday() {
    return this.getTUIDayFormat(moment(localStorage.getItem("todaysDate")).add(-1, 'year').format("YYYY-MM-DD"));
  }
  getTodayDate() {
    return (moment(localStorage.getItem("todaysDate")).format("YYYY-MM-DD"));
  }
  getLastYearStartMonth() {
    let year = moment().year() - 1;
    let momentOne = moment(new Date(year, 0, 1));
    return this.getTUIDayFormat(momentOne.format("YYYY-MM-DD"));
  }
  getLastYearEndMonth() {
    let year = moment().year() - 1;
    let momentOne = moment(new Date(year, 11, 31));
    return this.getTUIDayFormat(momentOne.format("YYYY-MM-DD"));
  }
  getLastQuarterStartDate() {
    let lastQrt = moment().quarter(moment().quarter()).startOf('quarter').add(-1, 'day');
    return this.getTUIDayFormat(moment(lastQrt).quarter(moment(lastQrt).quarter()).startOf('quarter').format("YYYY-MM-DD"));
  }
  getLastQuarterEndDate() {
    let lastQrt = moment().quarter(moment().quarter()).startOf('quarter').add(-1, 'day');
    return this.getTUIDayFormat(moment(lastQrt).quarter(moment(lastQrt).quarter()).endOf('quarter').format("YYYY-MM-DD"));
  }
  get45DaysBeforeTodaysDate() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(-45, 'day').format("YYYY-MM-DD")));
  }
  get45DaysAfterTodaysDate() {
    return this.getTUIDayFormat((moment(localStorage.getItem("todaysDate")).add(45, 'day').format("YYYY-MM-DD")));
  }
  getJobCentralAccess() {
    let count = this.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.JOB_CENTRAL).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  getClientTimesheetAccess() {
    let count = this.getModuleAccess().filter(r => r.moduleKey === MODULE_CONSTANTS.CLIENT_FACING_TIMESHEET).length;
    if (count > 0) {
      return true;
    }
    return false;
  }
  exportExcelTable(fileName: string, tableIds: string[]) {
    const workbook = new ExcelJS.Workbook();

    const sheet1 = workbook.addWorksheet(fileName);
    this.addTablesToSheet(sheet1, tableIds);

    // STEP 4: Save the workbook
    workbook.xlsx.writeBuffer().then(buffer => {
      const blob = new Blob([buffer], { type: 'application/octet-stream' });
      FileSaver.saveAs(blob, fileName + ".xlsx");
    });
  }

  private addTablesToSheet(sheet: ExcelJS.Worksheet, tableIds: string[]): void {
    let currentRow = 1;
    tableIds.forEach(id => {
      const table = document.getElementById(id) as HTMLTableElement;
      const rows = table?.rows;

      for (let i = 0; i < rows.length; i++) {
        const excelRow = sheet.getRow(currentRow);
        const cells = rows[i].cells;

        for (let j = 0; j < cells.length; j++) {
          let isHeading = false;
          const cell = excelRow.getCell(j + 1);
          const rawText = cells[j].innerText.trim();
          let isRightAlign = false;
          let isCenterAlign = false;

          // Detect type: date, percentage, number
          let value: any = rawText;
          let isNumeric = /^-?\d+(\.\d+)?$/.test(rawText.replace(/,/g, ''));
          let isPercent = /^\d+(\.\d+)?%$/.test(rawText);
          let isDate = /^\d{4}-\d{2}-\d{2}$/.test(rawText);
          let isColon = /^[^ :]+:[^ :]+$/.test(rawText);

          if (isPercent) {
            value = parseFloat(rawText.replace('%', '')) / 100;
            cell.numFmt = '0.00%';
          } else if (isDate) {
            value = new Date(rawText);
            cell.numFmt = 'yyyy-mm-dd';
          } else if (isNumeric) {
            value = parseFloat(rawText.replace(/,/g, ''));
            cell.numFmt = '#,##0.00';
          }

          cell.value = value;

          // Styling
          cell.font = { name: 'Calibri' };
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };

          if (rows[i].parentElement?.tagName === 'THEAD') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFD3D3D3' }
            };
            cell.font = { name: 'Calibri', bold: true };
          } else if (rows[i].parentElement?.tagName === 'TFOOT') {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
            };
            cell.font = { name: 'Calibri', bold: true };
          }
          if (cells[j].className.includes('custom-heading')) {
            isHeading = true;
          }
          if (cells[j].className.includes('custom-right-align')) {
            isRightAlign = true;
          }
          if (cells[j].className.includes('custom-center-align')) {
            isCenterAlign = true;
          }
          if (cells[j].className.includes('font-size-h3')) {
            cell.font = { size: 18 };
          }
          if (cells[j].colSpan > 1) {
            sheet.mergeCells(currentRow, j + 1, currentRow, cells[j].colSpan);
          }
          if (isHeading) {
            cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
            };
            cell.font = { name: 'Calibri', bold: true };
          }
          if (isRightAlign) {
            cell.alignment = { horizontal: 'right' };
          }
          else if (isCenterAlign) {
            cell.alignment = { horizontal: 'center' };
          }
          else if (isDate) {
            cell.alignment = { horizontal: 'center' };
          } else if (isPercent || isNumeric || isColon) {
            cell.alignment = { horizontal: 'right' };
          } else {
            cell.alignment = { horizontal: 'left' };
          }
        }

        excelRow.commit();
        currentRow++;
      }
      currentRow += 2;
    });

    // Auto column widths
    sheet.columns?.forEach(col => {
      if (col && typeof col.eachCell === 'function') {
        let maxLen = 10;
        col.eachCell({ includeEmpty: true }, cell => {
          const val = cell.value ? cell.value.toString() : '';
          maxLen = Math.max(maxLen, val.length);
        });
        col.width = maxLen + 2;
      }
    });
  }

  private addJsonTable(): void {
    let jsonTableData = [ //Temp data
      { Name: 'Charlie', Role: 'Manager', Salary: 135000.75, JoiningDate: '2023-05-12', Bonus: 0.15 },
      { Name: 'Diana', Role: 'Developer', Salary: 98000.5, JoiningDate: '2022-11-01', Bonus: 0.12 }
    ];

    const workbook = new ExcelJS.Workbook();
    const sheet = workbook.addWorksheet('From JSON');


    const headers = Object.keys(jsonTableData[0]);
    const headerRow = sheet.addRow(headers);

    headerRow.eachCell(cell => {
      cell.font = { name: 'Calibri', bold: true };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFD3D3D3' }
      };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
      cell.alignment = { horizontal: 'center' };
    });

    for (const row of jsonTableData as Record<string, any>[]) {
      const excelRow = sheet.addRow(headers.map(h => row[h]));
      excelRow.eachCell((cell, colNumber) => {
        const val = cell.value;
        cell.font = { name: 'Calibri' };
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };

        const header = headers[colNumber - 1];

        if (typeof val === 'number' && header !== 'Bonus') {
          cell.numFmt = '#,##0.00';
          cell.alignment = { horizontal: 'right' };
        } else if (typeof val === 'number' && header === 'Bonus') {
          cell.numFmt = '0.00%';
          cell.alignment = { horizontal: 'right' };
        } else if (val instanceof Date || /^\d{4}-\d{2}-\d{2}$/.test(val as string)) {
          cell.numFmt = 'yyyy-mm-dd';
          cell.alignment = { horizontal: 'center' };
        } else {
          cell.alignment = { horizontal: 'left' };
        }
      });
    }

    // Auto column widths
    sheet.columns?.forEach(col => {
      if (col && typeof col.eachCell === 'function') {
        let maxLen = 10;
        col.eachCell({ includeEmpty: true }, cell => {
          const val = cell.value ? cell.value.toString() : '';
          maxLen = Math.max(maxLen, val.length);
        });
        col.width = maxLen + 2;
      }
    });
  }

  /**
   * Converts a local date string (YYYY-MM-DD) to a UTC ISO string.
   * @param {string} dateStr - Local date string in YYYY-MM-DD format
   * @param {boolean} isEndOfDay - If true, sets time to 23:59:59.999, else to 00:00:00.000
   * @returns {string} UTC ISO date string
   */
  public convertLocalDateToUtcIso(dateStr: string, isEndOfDay = false) {
    const timeSuffix = isEndOfDay ? 'T23:59:59.999' : 'T00:00:00.000';
    const localDateTime = new Date(dateStr + timeSuffix);
    return localDateTime.toISOString();
  }

  formatDateRange(range: TuiDayRange): string {
    return `${range.from.toString('YMD' as TuiDateMode, '-')} - ${range.to.toString('YMD' as TuiDateMode, '-')}`;
  }

  createDateRangeItem(name: string, from: TuiDay, to: TuiDay): any {
    const range = new TuiDayRange(from, to);

    return {
      range,
      name,
      description: this.formatDateRange(range),
    };
  }
  createDateRangeItemNew(
  name: string,
  startDate: TuiDay,
  endDate: TuiDay,
): { name: string; range: TuiDayRange } {
  return {
    name,
    range: new TuiDayRange(startDate, endDate),
  };
}
}
